import { request, getCalendarEvent, wpFetch } from "../main.top";
import { openResearchPopup } from "../pages/global/form-popup";
import { TinySliderInstance } from "tiny-slider";
/**
 * @param {function({string:Array})} callback
 */
export function getCategories(callback = function () {}) {
    // callback([]);
    request(
        "POST",
        ajaxurl,
        {
            action: "getCategories",
        },
        (data) => callback(JSON.parse(data))
    );
}

/**
 * @param {function({string:Array})} callback
 */
export function getTags(callback = function () {}) {
    request(
        "POST",
        ajaxurl,
        {
            action: "getTags",
        },
        function (data) {
            callback(JSON.parse(data));
        }
    );
}

export function getEvents(reqBody) {
    reqBody["companiesParent"] = companiesParent.term_id;
    reqBody["sectorsParent"] = sectorsParent.term_id;
    reqBody["yearsParent"] = yearsParent.term_id;
    reqBody["quartersParent"] = quartersParent.term_id;

    const eventsPromise = new Promise((success, fail) => {
        request("POST", ajaxurl, reqBody, (data) => {
            success(JSON.parse(data));
        });
    });

    return eventsPromise;
}

/**
 * @param {Array} data The decoded response from the WordPress
 * @param {HTMLElement} sliderContainer The slides container element.
 * @returns {void}
 */

var eventsMissedScheduleds = [];
// console.log("v1");

export function fillSlider(data, sliderContainer, order = "oldestToNewest", typeEvent) {
    eventsMissedScheduleds = [];

    let events = data.posts;
    // console.log("typeEvent => ", typeEvent);

    if (!sliderContainer) return false;

    sliderContainer.innerHTML = "";
    if (events.length === 0) {
        sliderContainer.parentElement.parentElement.classList.add("empty");
        return false;
    }
    sliderContainer.parentElement.parentElement.classList.remove("empty");

    // Defines the order
    let eventsArray = events;
    if (order == "newestToOldest") {
        eventsArray.sort((a, b) => b.eventDate - a.eventDate);
    } else if (order == "oldestToNewest") {
        eventsArray.sort((a, b) => a.eventDate - b.eventDate);
    }

    let arrayNewEvents = [];

    if (typeEvent == "eventFuture") {
        let currentDateNew = new Date();

        Date.prototype.addHours = function (h) {
            this.setHours(this.getHours() + h);
            return this;
        };

        // console.log("eventsArray => ", eventsArray);

        eventsArray.forEach(function (event, i) {
            let eventDateNew = new Date(event.eventDate).addHours(3);
            if (currentDateNew < eventDateNew) {
                arrayNewEvents.push(event);
            } else {
                event.status = "publish";
                eventsMissedScheduleds.push(event);
            }
        });
    } else {
        arrayNewEvents = [...eventsMissedScheduleds, ...eventsArray];
        // arrayNewEvents = eventsArray;
    }

    // console.log("typeEvent => ", typeEvent);
    // console.log("eventsMissedScheduleds => ", eventsMissedScheduleds);

    // if (typeEvent == "eventFuture") {
    //     console.log("arrayNewEvents => ", arrayNewEvents);
    // }

    // Gallery View
    arrayNewEvents.forEach(function (event, i) {
        let eventElement = document.createElement("article");
        eventElement.classList.add("event", "item", event.status);
        eventElement.setAttribute("data-permalink", event.permalink);

        let thumbnail = "";
        if (event.thumbnail) {
            thumbnail = event.thumbnail
                ? event.thumbnail.replace("https://mzgroupcombr.wpcomstaging.com", "https://www.mzgroup.com.br")
                : event.thumbnail.url.replace("https://mzgroupcombr.wpcomstaging.com", "https://www.mzgroup.com.br");
        }

        const statusTagText = event.isLive ? live : event.status === "future" ? scheduleTxt : playTxt;
        const statusTagElm = `<span class="tag ${event.status} ${event.isLive ? "live" : ""}">` + statusTagText + "</span>";
        eventElement.innerHTML = `
            <div class="thumbnail">
                <img src="${thumbnail}" loading="lazy">
                ${statusTagElm}
            </div>
        `;

        let eventNavbar = document.createElement("nav");
        eventNavbar.classList.add("eventNavbar");

        const metaBlock = document.createElement("div");
        metaBlock.classList.add("meta");

        const postDateElm = document.createElement("time");
        postDateElm.classList.add("eventDate");

        if (event.eventDate && !event.isLive) {
            const date = new Date(event.eventDate);
            const localeDate = date.toLocaleString(lang, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });

            const time = date.toLocaleString("en", { timeStyle: "short", hour12: true, timeZone: "UTC" }).replace(":00", "").replace("GMT-3", "");
            //const time = date.toLocaleString("en", { timeStyle: "short" }).replace(":00", "").replace("GMT-3", "");
            //console.log('IF => ', event.title + '-' +event.status + ' / data: ' + time)
            postDateElm.ariaLabel = date.toLocaleString(lang, { dateStyle: "medium", timeStyle: "medium", timeZone: "UTC" });

            postDateElm.setAttribute("data-date", localeDate);
            postDateElm.setAttribute("data-time", ` - ${time}`);

            // console.log(event.title, " eventDate => ", event.eventDate);
            // console.log(event.title, " date => ", date);
            // console.log(event.title, " time => ", time);
        } else {
            // const date = new Date(event.eventDate);
            // const localeDate = date.toLocaleString(lang, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });
            // const time = date.toLocaleString("en", { timeStyle: "short", hour12: true, timeZone: "UTC" }).replace(":00", "").replace("GMT-3", "");

            // console.log(event.title, " eventDate => ", event.eventDate);
            // console.log(event.title, " date => ", date);
            // console.log(event.title, " time => ", time);
            //console.log('Else => ', event.title + '-' +event.status + ' / data: ' + localeDate)
            eventElement.classList.add("live");

            postDateElm.classList.add("now");
            postDateElm.innerHTML = nowTxt;
        }

        metaBlock.appendChild(postDateElm);

        const availableLangsElm = document.createElement("span");
        availableLangsElm.classList.add("availableLanguages");

        let availableLangs = "";
        if (event.isLive && Array.isArray(event.webcastLinks)) {
            availableLangs = event.webcastLinks
                .map((item) => {
                    return item.language[0];
                })
                .join("/");
        } else {
            const videoLinks = event.videoLinks;

            availableLangs = Object.keys(videoLinks)
                .map((key) => {
                    return key.substring(0, 2);
                })
                .join("/");
        }

        availableLangsElm.innerHTML = availableLangs;
        metaBlock.appendChild(availableLangsElm);
        eventNavbar.appendChild(metaBlock);

        const bottomPart = document.createElement("div");
        bottomPart.classList.add("bottom");

        let playButton = document.createElement("button");
        playButton.setAttribute("data-webcastname", event.title);
        // playButton.setAttribute("data-permalink", event.link);
        playButton.setAttribute("data-permalink", event.permalink);

        playButton.classList.add("watchWebcast");
        playButton.addEventListener("click", (e) => {
            const name = e.target.getAttribute("data-webcastname");
            const permalink = e.target.getAttribute("data-permalink");

            openResearchPopup(name, permalink, document.getElementById("signInPopup"));
            // location.href = event.permalink;
        });

        bottomPart.appendChild(playButton);

        let detailsText = "";
        event.industries.forEach(function (industry, i, ref) {
            let spacing = i === 0 ? "" : i === ref.length - 1 ? andText : ", ";
            detailsText += spacing + industry;
        });

        let navbarDetails = document.createElement("span");
        navbarDetails.classList.add("details");
        navbarDetails.innerHTML = detailsText;
        bottomPart.appendChild(navbarDetails);

        eventNavbar.appendChild(bottomPart);
        eventElement.appendChild(eventNavbar);

        const containedElm = document.createElement("div");
        containedElm.appendChild(eventElement);
        sliderContainer.appendChild(containedElm);
    });
    sliderContainer.classList.remove("loading");

    return true;
}

/**
 * Fill in the table with a list of Webcasts
 * @param {HTMLElement} tableContainer The Element that contains the table.
 * @param {Array} withThis The Webcasts Array.
 * @param {Boolean} wScheduleBtn Does this table need the schedule button?
 * @param {Boolean} DateInit Does this table need the start date?
 */
export function fillInTable(tableContainer, withThis, wScheduleBtn, wAccessLinks) {
    if (!tableContainer) return;

    const posts = withThis.posts;
    // console.log(tableContainer, "posts => ", posts);

    if (document.body.classList.contains("single-eventos")) {
        languages = { "pt-br": "Português", en: "English" };
        joinMeetingMult = { "pt-br": "Acessar Reunião", en: "Join Meeting" };
    }

    /**
     * @type HTMLTableElement
     */
    let table = tableContainer.querySelector("table");
    if (posts.length === 0) {
        tableContainer.classList.add("empty");
        return;
    }
    tableContainer.classList.remove("empty");

    table.tBodies[0].innerHTML = "";
    posts.forEach(function (event, i) {
        let newRow = table.tBodies[0].insertRow();
        let company = newRow.insertCell();
        
        // console.log("event => ", event);
        // if (event.company == "") {
        //     // console.log("event without company => ", event);
        // }

        let shortName =
            event.company["shortName"] != ""
                ? event.company["shortName"]
                : event.categories.find((category) => category.category_parent === 8).cat_name;
        // let shortName = event.company["shortName"] ? event.company["shortName"] : "";
        company.innerHTML = `
            <span class="shortName">${shortName || event.title}</span>
        `;

        let eventDate = new Date(event.eventDate);
        let eventName = newRow.insertCell();
        let quarter = event.quarter ? event.quarter : event.categories.find((category) => category.category_parent === 10)?.cat_name;
        let year = event.year ? event.year : event.categories.find((category) => category.category_parent === 17)?.cat_name;
        // let dateEvent = new Date(event.date);
        // let fullYear = dateEvent.getFullYear();
        // let quarter = event.quarter ? event.quarter : "";
        // let year = event.year ? event.year : "";
        // eventName.innerHTML = quarter + "/" + (year && year.length > 0 ? year : fullYear);
        eventName.innerHTML = quarter + "/" + year;

        // console.log("event => ", year, fullYear);

        // let formatedDisclosureDate = new Date(event.date).toLocaleString(lang, {
        //     day: '2-digit',
        //     month: '2-digit',
        //     year: 'numeric'
        // });

        let formatedDisclosureDate = new Date(event.eventDataResults).toLocaleString(lang, {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        let isPostMarketClose = event.postMarketClose ? "post" : "pre";
        let disclosureDateElement = newRow.insertCell();
        disclosureDateElement.innerHTML = formatedDisclosureDate + '<i class="indicator ' + isPostMarketClose + '"></i>';

        const statusTagElm = `<span class="tag ${event.status} ${event.isLive ? "live" : ""}">` + live + "</span>";

        let state = event.isLive
            ? statusTagElm
            : eventDate.toLocaleString(lang, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });

        let eventState = newRow.insertCell();
        eventState.innerHTML = state;

        if (wAccessLinks) {
            for (let slug in languages) {
                // const playButtonPermalink = event.link;
                const playButtonPermalink = event.permalink;
                const playButtonAttr = "_self";

                let eventLanguage = newRow.insertCell();
                eventLanguage.classList.add("language", slug);

                const playButton = document.createElement("a");
                if (event.isLive) {
                    playButton.href = playButtonPermalink;
                    playButton.target = playButtonAttr;
                    playButton.innerHTML = joinMeetingMult[slug];
                } else {
                    playButton.target = playButtonAttr;
                    playButton.innerHTML = joinMeetingMult[slug];
                    playButton.style.cursor = "pointer";

                    playButton.addEventListener("click", (e) => {
                        // openResearchPopup(event.title, playButtonPermalink);
                        location.href = event.permalink;
                    });
                }

                if (event.status === "future" && !event.isLive) {
                    eventLanguage.classList.add("disabled");
                    eventLanguage.innerHTML = "-";
                } else {
                    eventLanguage.appendChild(playButton);
                }
            }
        }

        if (wScheduleBtn) {
            let addToCalendar = newRow.insertCell();

            let calendarLink = document.createElement("a");
            calendarLink.setAttribute("target", "_blank");
            calendarLink.classList.add("calendarLink");
            calendarLink.setAttribute(
                "href",
                getCalendarEvent(
                    event.title,
                    '<a target="_blank" href="' + event.permalink + '">Clique aqui</a> para acessar o Webcast!',
                    event.permalink,
                    event.eventDate,
                    event.eventDateEnd
                )
            );
            addToCalendar.appendChild(calendarLink);
            addToCalendar.classList.add("addToCalendar");
        }
    });
    tableContainer.classList.remove("loading");
}

export function fillDiscovery(data, sliderContainer) {
    if (!sliderContainer) return false;
    sliderContainer.innerHTML = "";

    const events = data.posts;

    // Gallery View
    events.forEach(function (event, i) {
        let eventElement = document.createElement("a");
        eventElement.classList.add("event", "item", "item--discovery", event.status);
        eventElement.setAttribute("href", event.permalink);
        //console.log(event)

        let thumbnail = "";
        if (event.thumbnail) {
            thumbnail = event.thumbnail ? event.thumbnail : event.thumbnail.url;
        }

        let tags = "";
        if (!!event.tags) {
            event.tags.forEach((e, i) => {
                tags += `<span>${e.name}</span>`;
            });

            tags = `<div class="tags">${tags}</div>`;
        }

        const date = new Date(event.date);
        const localeDate = date.toLocaleString(lang, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });
        eventElement.innerHTML = `
            <div class="thumbnail">
                <img src="${thumbnail}" loading="lazy" />
                ${tags}
            </div>
            <nav class="postNavbar">
                <time class="date">${localeDate}</time>
                <h3 class="title" href="${event.permalink}" title="${event.title}">${event.title}</h3>
                <p class="resume">${event.resume}...</p>
            </nav>
        `;

        const theOuterElm = document.createElement("div");
        theOuterElm.appendChild(eventElement);

        sliderContainer.appendChild(theOuterElm);
    });

    sliderContainer.classList.remove("loading");
    return true;
}

export function fillDiscoveryCases(data, sliderContainer) {
    if (!sliderContainer) return false;
    sliderContainer.innerHTML = "";

    const events = data.posts;

    // Gallery View
    events.forEach(function (event, i) {
        let eventElement = document.createElement("a");
        eventElement.classList.add("event", "item", "item--cases", event.status);
        eventElement.setAttribute("href", event.permalink);

        let thumbnail = "";
        if (event.thumbnail) {
            thumbnail = event.thumbnail ? event.thumbnail : event.thumbnail.url;
        }

        eventElement.innerHTML = `
            <img src="${thumbnail}" loading="lazy" />
            <div class="info">
                <span class="name">${event.peopleName}</span>
                <span class="company">${event.description}</span>
            </div>
        `;

        const theOuterElm = document.createElement("div");
        theOuterElm.appendChild(eventElement);

        sliderContainer.appendChild(theOuterElm);
    });

    sliderContainer.classList.remove("loading");
    return true;
}

/**
 * Fill in the table with a list of Webcasts
 * @param {HTMLElement} tableContainer The Element that contains the table.
 * @param {Array} withThis The Webcasts Array.

 */
export function fillDiscoveryInTable(tableContainer, withThis) {
    if (!tableContainer) return;

    const posts = withThis.posts;

    if (document.body.classList.contains("single-eventos")) {
        languages = { "pt-br": "Português", en: "English" };
        joinMeetingMult = { "pt-br": "Acessar Reunião", en: "Join Meeting" };
    }

    /**
     * @type HTMLTableElement
     */
    let table = tableContainer.querySelector("table");
    if (posts.length === 0) {
        tableContainer.classList.add("empty");
        return;
    }
    tableContainer.classList.remove("empty");

    table.tBodies[0].innerHTML = "";
    posts.forEach(function (event, i) {
        let newRow = table.tBodies[0].insertRow();
        let colTitle = newRow.insertCell();
        colTitle.classList.add("title");
        colTitle.innerHTML = `
            <a href="${event.permalink}"><span class="title">${event.title}</span></a>
        `;

        let eventDateFormated = new Date(event.date).toLocaleString(lang, {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        let colDate = newRow.insertCell();
        colDate.classList.add("date");
        colDate.innerHTML = eventDateFormated;

        let eventTagsFormated = "";

        if (event.tags)
            event.tags.forEach((e) => {
                eventTagsFormated += `<span class="tags">${e.name}</span>`;
            });

        let colTags = newRow.insertCell();
        colTags.classList.add("tags-list");
        colTags.innerHTML = "<div>" + eventTagsFormated + "</div>";
    });
    tableContainer.classList.remove("loading");
}

/**
 * Disables webcasts rows
 * @param {Array} rows
 * @param {Number} toIndex
 */
export function delayedRowReset(rows, toIndex) {
    const amount = rows.length - 1;

    const rowsToRemove = rows.slice(Math.min(amount, toIndex));
    rowsToRemove.reverse().forEach(async (rowObject, i) => {
        // await sleep(144 * i);
        await sleep(610);
        rowObject.row.classList.remove("ready");

        await sleep(610);
        rowObject.row.remove();
    });
}

/**
 *
 * @param {HTMLElement} container
 * @param {String} innerHTML
 * @param  {...String} customClasses
 * @returns {HTMLElement}
 */
export function createGalleryRow(container, innerHTML = "", ...customClasses) {
    const newRow = document.createElement("div");
    newRow.classList.add("galleryRow", ...customClasses);
    newRow.innerHTML = '<div class="items">' + innerHTML + "</div>";
    container.appendChild(newRow);

    return newRow;
}

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

//Hide AddCalendar in Live
let hideButton = $(".live,.liveEvents");
if (hideButton !== null) {
    hideButton.find(".watchWebcast").hide();
}
